import React from "react";
import Slider from "react-slick";
import { siteUrl, slickDot } from "../../utils/constants";
import type { News } from "../../types/strapi";
import { mediaUrl } from "../../utils/imageUtils";

interface NewsLinkItemProps {
  newsItem: News;
}

const NewsLinkItem: React.FC<NewsLinkItemProps> = ({ newsItem }) => {
  const imageUrl = newsItem.image?.formats?.small?.url ?? newsItem.image?.url;

  return (
    <>
      <div className="thumbnail" style={imageUrl ? undefined : { minHeight: "300px" }}>
        <a href={newsItem.url} target="_blank" rel="noopener noreferrer">
          {imageUrl && (
            <img className="w-100" src={mediaUrl(imageUrl)} alt={newsItem.heading} />
          )}
        </a>
      </div>
      <div className="content">
        <div className="inner">
          <div className="content_heading">
            <h4 className="title">
              <a href={newsItem.url} target="_blank" rel="noopener noreferrer">
                {newsItem.heading}
              </a>
            </h4>
            <div className="category_list">
              <a href={newsItem.url} target="_blank" rel="noopener noreferrer">
                {newsItem.text}
              </a>
            </div>
          </div>
          <div className="content_footer">
            <a
              href={newsItem.url}
              target="_blank"
              rel="noopener noreferrer"
              className="rn-btn btn-opacity"
            >
              Read More
            </a>
          </div>
        </div>
        <a
          className="transparent_link"
          href={newsItem.url}
          target="_blank"
          rel="noopener noreferrer"
        />
      </div>
    </>
  );
};

interface NewsSectionProps {
  news?: News[];
}

const NewsSection: React.FC<NewsSectionProps> = ({ news }) => {
  if (!news || news.length === 0) {
    return null;
  }

  return (
    <div className="rn-blog-area pt--120 pb--140 bg_color--5">
      <div className="container">
        <div className="row align-items-end">
          <div className="col-lg-12">
            <div className="section-title text-center">
              <span className="subtitle">News</span>
              <h3 className="title">Latest Updates</h3>
            </div>
          </div>
        </div>
        <div className="row mt_sm--30 rn-slick-dot slick-space-gutter--15 slickdot--20 row--0">
          <div className="col-lg-12">
            <Slider {...slickDot}>
              {news.map((newsItem) => (
                <div className="im_box" key={newsItem.id}>
                  <NewsLinkItem newsItem={newsItem} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsSection;
